import { ColDef } from 'ag-grid-community';
import { Colors } from 'routes/BudgetModule/config/constants';
import { getAgentColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { DATE_FILTER } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import { floatingFilter } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import { dateFormatter, percentageFormatter } from 'ui/AgGridReact/formatters';
import { percentageGetter } from 'ui/AgGridReact/getters';
import {
    ECHELON,
    FILIERE,
    GRADE,
    RAISE_PERCENT,
    START_DATE,
} from '../../helpers/constants';

const baseColDef = { ...floatingFilter, sortable: true, resizable: true };

export const getColDefs = (t: TranslationT): ColDef[] => [
    {
        resizable: true,
        headerName: t('humanResources.simulation.gridGrade'),
        cellRenderer: 'gridEchelonsCellRenderer',
    },
    {
        ...getAgentColumn(),
        ...baseColDef,
        flex: 1,
        sort: 'asc',
    },
    {
        ...baseColDef,
        flex: 2,
        field: GRADE,
        headerName: t('humanResources.simulation.grade'),
    },
    {
        ...baseColDef,
        flex: 2,
        field: FILIERE,
        headerName: t('humanResources.simulation.filiere'),
    },
    {
        ...DATE_FILTER,
        headerName: t('humanResources.simulation.nextEchelonDate'),
        field: START_DATE,
        valueGetter: (params) =>
            params.data && params.data.startDate !== ''
                ? new Date(params.data.startDate)
                : undefined,
        valueFormatter: dateFormatter,
        flex: 1,
    },
    {
        ...baseColDef,
        field: ECHELON,
        headerName: t('humanResources.simulation.nextEchelon'),
    },
    {
        ...baseColDef,
        field: RAISE_PERCENT,
        headerName: t('humanResources.simulation.increasePercentage'),
        filterValueGetter: percentageGetter,
        valueFormatter: percentageFormatter,
        cellRenderer: 'chipCellRenderer',
        cellRendererParams: {
            getColor: () => Colors.ORANGE,
            size: 'small',
        },
    },
];
